module.exports = __webpack_public_path__ + "files/bb5c534120fd49233342a430257b49fc.png";